module.exports = __webpack_public_path__ + "static/img/1-14.d91b257.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/1-14.png
// module id = 215
// module chunks = 0